<template>
  <div v-if="$store.state.settings.user && $store.state.settings.user.profile">
    <section class="section">
      <div class="container">
        <Title> Visibility</Title>

        <div class="columns is-multiline">
          <div class="column is-3">
            <div
              v-if="$store.state.settings.user.profile.notifications"
              class="card"
            >
              <header class="card-header">
                <div class="card-header-title">
                  Notifications - Package change
                </div>
              </header>
              <div class="card-content">
                <p class>
                  Show notifications on package changes in the computer package
                  view.
                </p>

                <a
                  class="button"
                  :class="{
                    'is-primary':
                      $store.state.settings.user.profile.notifications
                        .packageChange,
                  }"
                  @click="
                    save('profile', 'notifications', {
                      packageChange: !$store.state.settings.user.profile
                        .notifications.packageChange,
                    })
                  "
                >
                  <span class="icon">
                    <i class="mdi mdi-check-circle"></i>
                  </span>
                  <span>
                    {{
                      $store.state.settings.user.profile.notifications
                        .packageChange
                        ? "On"
                        : "Off"
                    }}
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div
              v-if="$store.state.settings.user.profile.notifications"
              class="card"
            >
              <header class="card-header">
                <div class="card-header-title">
                  Notifications - Computer added
                </div>
              </header>
              <div class="card-content">
                <p class>
                  Show notification when a new computer is added in the
                  domain/computers view.
                </p>

                <a
                  class="button"
                  :class="{
                    'is-primary':
                      $store.state.settings.user.profile.notifications
                        .computerAdd,
                  }"
                  @click="
                    save('profile', 'notifications', {
                      computerAdd: !$store.state.settings.user.profile
                        .notifications.computerAdd,
                    })
                  "
                >
                  <span class="icon">
                    <i class="mdi mdi-check-circle"></i>
                  </span>
                  <span>
                    {{
                      $store.state.settings.user.profile.notifications
                        .computerAdd
                        ? "On"
                        : "Off"
                    }}
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div v-if="$store.state.settings.user.profile.infobar" class="card">
              <header class="card-header">
                <div class="card-header-title">Status bar - Working status</div>
              </header>
              <div class="card-content">
                <p class>Show a status bar for the current working package.</p>

                <a
                  class="button"
                  :class="{
                    'is-primary':
                      $store.state.settings.user.profile.infobar.workingStatus,
                  }"
                  @click="
                    save('profile', 'infobar', {
                      workingStatus: !$store.state.settings.user.profile.infobar
                        .workingStatus,
                    })
                  "
                >
                  <span class="icon">
                    <i class="mdi mdi-check-circle"></i>
                  </span>
                  <span>
                    {{
                      $store.state.settings.user.profile.infobar &&
                      $store.state.settings.user.profile.infobar.workingStatus
                        ? "On"
                        : "Off"
                    }}
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div v-if="$store.state.settings.user.profile.guides" class="card">
              <header class="card-header">
                <div class="card-header-title">Guide - Get started</div>
              </header>
              <div class="card-content">
                <p class>
                  Show the "Get started"-guide when a domain is incomplete.
                </p>

                <a
                  class="button"
                  :class="{
                    'is-primary':
                      $store.state.settings.user.profile.guides.getStarted ||
                      $store.state.settings.user.profile.guides.getStarted ===
                        undefined,
                  }"
                  @click="
                    save('profile', 'guides', {
                      getStarted:
                        $store.state.settings.user.profile.guides.getStarted ===
                          undefined ||
                        $store.state.settings.user.profile.guides.getStarted
                          ? false
                          : true,
                    })
                  "
                >
                  <span class="icon">
                    <i class="mdi mdi-check-circle"></i>
                  </span>
                  <span>
                    {{
                      $store.state.settings.user.profile.guides.getStarted ||
                      $store.state.settings.user.profile.guides.getStarted ===
                        undefined
                        ? "On"
                        : "Off"
                    }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section ">
      <div class="container">
        <Title>Account</Title>

        <div
          v-if="$store.state.settings.user.profile.session"
          class="columns is-multiline"
        >
          <div class="column is-3">
            <div class="card">
              <header class="card-header">
                <div class="card-header-title">Session timeout</div>
              </header>

              <div class="card-content">
                <p>
                  Configure how long until the session expires. Default is 15
                  minutes, and minimum 5.
                </p>

                <BInput
                  v-model="timeout"
                  validation="required|numeric|min_value:5"
                  name="timeout"
                  type="number"
                  placeholder="Timeout in minutes"
                  icon="mdi mdi-timer-outline"
                  @valid="timeoutValid = $event"
                ></BInput>
              </div>

              <footer class="card-footer">
                <a
                  :disabled="!timeoutValid"
                  @click="saveTimeout()"
                  class="card-footer-item"
                  >Save</a
                >
              </footer>
            </div>
          </div>

          <div
            v-if="
              $store.state.settings.user.profile.auth &&
                $store.state.settings.server &&
                $store.state.settings.server.emailEnabled &&
                $store.state.settings.server.twoFactorAuthEnabled
            "
            class="column is-3"
          >
            <div class="card">
              <header class="card-header">
                <div class="card-header-title">Two factor authentication</div>
              </header>
              <div class="card-content">
                <p class>Enable two factor authentication via email.</p>

                <a
                  class="button"
                  :class="{
                    'is-primary':
                      $store.state.settings.user.profile.auth.twoFactor &&
                      $store.state.settings.user.profile.auth.twoFactor.enabled,
                  }"
                  @click="
                    save('profile', 'auth', {
                      twoFactor: {
                        when: 'always',
                        enabled: !(
                          $store.state.settings.user.profile.auth.twoFactor &&
                          $store.state.settings.user.profile.auth.twoFactor
                            .enabled
                        ),
                        method: 'mail',
                      },
                    })
                  "
                >
                  <span class="icon">
                    <i class="mdi mdi-check-circle"></i>
                  </span>
                  <span>
                    {{
                      $store.state.settings.user.profile.auth.twoFactor &&
                      $store.state.settings.user.profile.auth.twoFactor.enabled
                        ? "On"
                        : "Off"
                    }}
                  </span>
                </a>

                <div
                  v-if="
                    $store.state.settings.user.profile.auth.twoFactor &&
                      $store.state.settings.user.profile.auth.twoFactor.enabled
                  "
                >
                  <div class="columns is-multiline">
                    <div class="column is-12">
                      <p class="margin-top-2 margin-bottom-5">When?</p>
                      <CheckboxText
                        :checked="
                          $store.state.settings.user.profile.auth.twoFactor &&
                            $store.state.settings.user.profile.auth.twoFactor
                              .when === 'always'
                        "
                        @click="
                          save('profile', 'auth', {
                            twoFactor: {
                              ...$store.state.settings.user.profile.auth
                                .twoFactor,
                              ...{ when: 'always' },
                            },
                          })
                        "
                        >Always</CheckboxText
                      >

                      <CheckboxText
                        :checked="
                          $store.state.settings.user.profile.auth.twoFactor &&
                            $store.state.settings.user.profile.auth.twoFactor
                              .when === 'newFpIp'
                        "
                        @click="
                          save('profile', 'auth', {
                            twoFactor: {
                              ...$store.state.settings.user.profile.auth
                                .twoFactor,
                              ...{ when: 'newFpIp' },
                            },
                          })
                        "
                        >Unknown browser and IP</CheckboxText
                      >

                      <CheckboxText
                        :checked="
                          $store.state.settings.user.profile.auth.twoFactor &&
                            $store.state.settings.user.profile.auth.twoFactor
                              .when === 'newFp'
                        "
                        @click="
                          save('profile', 'auth', {
                            twoFactor: {
                              ...$store.state.settings.user.profile.auth
                                .twoFactor,
                              ...{ when: 'newFp' },
                            },
                          })
                        "
                        >Unknown browser</CheckboxText
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div class="card">
              <header class="card-header">
                <div class="card-header-title">Password</div>
              </header>
              <div class="card-content">
                <p class>Change account password.</p>

                <a class="button" @click="showPassword = true">
                  <span class="icon">
                    <i class="mdi mdi-lock"></i>
                  </span>
                  <span>Change</span>
                </a>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div class="card">
              <header class="card-header">
                <div class="card-header-title">E-mail</div>
              </header>
              <div class="card-content">
                <p class>Change account e-mail (username).</p>

                <a class="button" @click="showUsername = true">
                  <span class="icon">
                    <i class="mdi mdi-lock"></i>
                  </span>
                  <span>Change</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <Title>API Keys</Title>
        <ApiKeys></ApiKeys>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <Title>Active Sessions</Title>
        <Sessions></Sessions>
      </div>
    </section>

    <Password v-if="showPassword" v-model="showPassword"></Password>
    <Username v-if="showUsername" v-model="showUsername"></Username>
  </div>
</template>

<script>
export default {
  components: {
    Title: () => import("@/components/singles/Title.vue"),
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
    BInput: () => import("@/components/singles/BInput/component.vue"),
    Password: () => import("@/components/main/user/Password.vue"),
    Username: () => import("@/components/main/user/Username.vue"),
    Sessions: () => import("@/components/main/user/Sessions.vue"),
    ApiKeys: () => import("@/components/main/user/ApiKeys.vue"),
  },
  data() {
    return {
      apiKeys: null,
      timeoutValid: false,
      timeout: 15,
      showPassword: false,
      showUsername: false,
      sessions: [],
    };
  },
  async created() {
    await this.$store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "auth",
    });

    await this.$store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "notifications",
    });

    await this.$store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "infobar",
    });

    await this.$store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "session",
    });

    await this.$store.dispatch("settings/getUserSetting", {
      path: "profile",
      key: "guides",
    });

    if (this.$store.state.settings.user.profile.session.timeout)
      this.timeout = this.$store.state.settings.user.profile.session.timeout;
  },

  methods: {
    async save(path, key, value) {
      await this.$store.dispatch("settings/setUser", {
        path: path,
        key,
        value,
      });
    },

    saveTimeout() {
      if (this.timeoutValid) {
        this.save("profile", "session", {
          timeout: this.timeout,
        });

        this.$helpers.notify("Saved", "Session timeout was saved.", "success");
      }
    },
  },
};
</script>
